/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinqrdescription2Inputs */

const en_checkinqrdescription2 = /** @type {(inputs: Checkinqrdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Put the code up at the entrance or at the bar. Whoever scans it is checked in to your event’s Live Room and can show they are there – even without the app.`)
};

const de_checkinqrdescription2 = /** @type {(inputs: Checkinqrdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Häng den Code beim Eingang oder an der Bar auf. Wer ihn scannt, ist im Live Room deines Events eingecheckt und kann sich zeigen – auch ohne App.`)
};

/**
* | output |
* | --- |
* | "Put the code up at the entrance or at the bar. Whoever scans it is checked in to your event’s Live Room and can show they are there – even without the app." |
*
* @param {Checkinqrdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinqrdescription2 = /** @type {((inputs?: Checkinqrdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinqrdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinqrdescription2(inputs)
	return de_checkinqrdescription2(inputs)
});
export { checkinqrdescription2 as "checkinQrDescription" }